import React, {useContext, useState} from 'react';
import NavBar from '../components/NavBar.jsx';
import 'bootstrap/dist/css/bootstrap.css';
import '../../styles/root/home.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../config/AuthContext";
import Login from "./Login";

export default function Home() {
    const {isLoggedIn, userId, user, actualSite, setActualSite} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<string>())

    function selectPagina(valor: string) {
        navigate(valor);
    }

    function selectPortada(valor: string, site: string) {
        setActualSite(site);
        navigate(valor);
    }

    if (isLoggedIn) {
        return (
            <>
                <NavBar/>
                <div className="flex-container">
                    {user.portada && user.portada.map(value =>
                        <div className={`container ${value.imageclass}`}
                             onClick={() => selectPortada(value.enllac, value.nom)} key={value.nom}>
                            <div className="titolHome">{value.titol}</div>
                        </div>
                    )}
                </div>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
}
